import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  html, body {
    .disable-scroll {
      overflow: hidden;
    }
  }
`;
